import React from 'react';
import { NavLink } from 'react-router-dom';
import { nodeTabClass } from '../shared/railClasses';
import { useGradeSyncPath } from './gradeSyncPath';

// From grade sync's base: the tabs render inside each tab's own route, so a relative 'troubleshoot'
// resolved against the Troubleshoot page itself and led to /troubleshoot/troubleshoot.
const TABS = [
  { end: true, label: 'Teachers', to: '' },
  { end: false, label: 'Troubleshoot', to: '/troubleshoot' },
  { end: false, label: 'Platform health', to: '/platform' },
  { end: false, label: 'Rate limits', to: '/rate-limits' },
];

const GradeSyncTabs = () => {
  const gradeSyncPath = useGradeSyncPath();

  return (
    <div className="tw-mb-5 tw-border-0 tw-border-b tw-border-solid tw-border-spa-border">
      <nav aria-label="Grade sync views" className="tw-flex tw-flex-wrap tw-gap-0.5">
        {TABS.map(tab => (
          <NavLink
            key={tab.label}
            className={({ isActive }) => nodeTabClass(isActive)}
            end={tab.end}
            to={gradeSyncPath(tab.to)}
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default GradeSyncTabs;
